import { render, staticRenderFns } from "./shortcuts.vue?vue&type=template&id=0ccfcc48&scoped=true"
import script from "./shortcuts.vue?vue&type=script&lang=js"
export * from "./shortcuts.vue?vue&type=script&lang=js"
import style0 from "./shortcuts.vue?vue&type=style&index=0&id=0ccfcc48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccfcc48",
  null
  
)

export default component.exports